import React from "react";

const GilgitBaltistan = () => {
  return (
    <>
      <h1>Work in Progress</h1>
    </>
  );
};

export default GilgitBaltistan;
